export default __webpack_public_path__ + "static/media/logo_blue.dc6685a8.png";